import React, { useEffect, useRef, useState } from "react";
import style from "./style.module.css";
import { useNavigate } from "react-router-dom";
import FormPersonalTrainer from "../../Components/FormPersonalTrainer";
import DetailPersonalTrainer from "../../Components/DetailPersonalTrainer";
import LogoSilang from "../../Picture/logoSilang.png";
import LogoPensil from "../../Picture/logoPensil.png";
import FormPersonalTrainer2 from "../../Components/FormPersonalTrainer2";

const PersonalTrainerGym2 = (props) => {
  const navigate = useNavigate("");
  const [newAktif, setNewAktif] = useState(true);
  const [dataJumlahUserTrainer, setDataJumlahUserTrainer] = useState([]);
  const [namaTrainer, setNamaTrainer] = useState("");
  const [rfidTrainer, setRfidTrainer] = useState("");
  const [namaPeserta, setNamaPeserta] = useState("");
  const [namaPesertaValidasi, setNamaPesertaValidasi] = useState("");
  const [hasilRfidTrainer, setHasilRfidTrainer] = useState("");
  const [keteranganValidasi, setKeteranganValidasi] = useState("");
  const [sisaPertemuan, setSisaPertemuan] = useState("");
  const [berjalanPertemuan, setBerjalanPertemuan] = useState("");
  const [timestamp,setTimestamp]=useState("");
  const [nomorHp, setNomorHp] = useState("");

  const [scanKehadiranPt, setScanKehadiranPt] = useState(false);

  const url = props.url;

  // function ambil nama trainer dan user aktifnya
  const GetJumlahUserTrainer = async () => {
    const response = await fetch(`${url}/?op=getTrainerReader`);
    const data = await response.json();
    if (data !== null) {
      setDataJumlahUserTrainer(data);
    } else {
      setDataJumlahUserTrainer([]);
    }
  };
  // function ubah nama peserta
  const UbahNamaPeserta = (namaPeserta) => {
    setNamaPeserta(namaPeserta);
  };
  // function klik hadir
  const KlikHadir = (
    namaPeserta,
    rfid,
    nomorHp,
    namaTrainer,
    sisaPertemuan,
    berjalanPertemuan,
    timestamp
  ) => {
    setScanKehadiranPt(true);
    setNamaPesertaValidasi(namaPeserta);
    setNomorHp(nomorHp);
    setNamaTrainer(namaTrainer);
    setSisaPertemuan(sisaPertemuan);
    setBerjalanPertemuan(berjalanPertemuan);
    setTimestamp(timestamp);
  };
  // function cek rfid trainer
  const CekRfidTrainer = (value) => {
    setHasilRfidTrainer(value);
    if (value.length === 10 && value === rfidTrainer) {
      setKeteranganValidasi("");

      fetch(url + "/?op=updatePesertaTrainer", {
        method: "post",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body:
          "nama_peserta=" +
          namaPesertaValidasi +
          "&nomor_hp=" +
          nomorHp +
          "&nama_trainer=" +
          namaTrainer +
          "&sisa_pertemuan=" +
          sisaPertemuan +
          "&berjalan_pertemuan=" +
          berjalanPertemuan+
          "&timestamp=" +
          timestamp
      })
        .then((response) => response.json())
        .then((json) => {
          if (json === "Berhasil") {
            setScanKehadiranPt(false);
            setNewAktif(true);
            setNamaTrainer("");
            GetJumlahUserTrainer();
          }
        });
    } else {
      setKeteranganValidasi("RFID tidak sesuai");
    }
  };
  const inputRef = useRef(null);

  // function berhasil terkirim input user pt baru
  const Terkirim=(value)=>{
    if(value==="Terkirim"){
      GetJumlahUserTrainer();
    }
  }
  // setiap kali scanKehadiranPt true → auto fokus
  useEffect(() => {
    if (scanKehadiranPt && inputRef.current) {
      inputRef.current.focus();
    }
  }, [scanKehadiranPt]);

  // supaya input tidak kehilangan fokus
  useEffect(() => {
    const interval = setInterval(() => {
      if (scanKehadiranPt && inputRef.current) {
        if (document.activeElement !== inputRef.current) {
          inputRef.current.focus();
        }
      }
    }, 100); // cek tiap 0.5 detik

    return () => clearInterval(interval);
  }, [scanKehadiranPt]);


  // use effect
  useEffect(() => {
    GetJumlahUserTrainer();
  }, []);
  // use effect cek session
     useEffect(()=>{
         fetch(url + "/?op=cekSession", {
             credentials: "include", 
           })
           .then((response)=>response.json())
           .then((json)=>{
            
           if (json === "kosong") {
                 navigate("/", { replace: true });
               }else if(json ==="gym1"){
     navigate("/gym1", { replace: true });
               }else if(json ==="owner"){
     navigate("/owner", { replace: true });
               }
           })
         },[])

  return (
    <div className={style.containerAll}>
      <div
        style={{ display: scanKehadiranPt ? "flex" : "none" }}
        className={style.divPembatas}
      ></div>
      <div
        style={{ display: scanKehadiranPt ? "flex" : "none" }}
        className={style.divValidasi}
      >
        <div className={style.judulValidasi}>
          Validasi Kehadiran
          <div
            style={{ cursor: "pointer" }}
            onClick={() => setScanKehadiranPt(false)}
          >
            <img src={LogoSilang} />
          </div>
        </div>
        <div className={style.namaPesertaValidasi}>{namaPesertaValidasi}</div>
        <input
          ref={inputRef}
          value={hasilRfidTrainer}
          onChange={(e) => {
            CekRfidTrainer(e.target.value);
          }}
        />
        <div className={style.divTulisanScan}>Scan Id Trainer</div>
        <div className={style.keteranganValidasi}>{keteranganValidasi}</div>
      </div>
      <div className={style.containerKiri}>
        <div className={style.judulContainerKiri}>
          Trainer
          <div
            onClick={() => {
              setNamaTrainer("");
              setNamaPeserta("");
              setNewAktif(true);
            }}
            className={style.newContainerKiri}
          ><img src={LogoPensil}/></div>
        </div>
        <div className={style.divTabelKiri}>
          <table className={style.tabel}>
            <thead>
              <tr>
                <th>Nama</th>
                <th>User Aktif</th>
              </tr>
            </thead>
            <tbody>
              {dataJumlahUserTrainer.map((item, index) => (
                <tr key={index}>
                  <td
                    style={{
                      cursor: "pointer",
                      color: namaTrainer === item.nama ? "blue" : "",
                    }}
                    onClick={() => {
                      setNewAktif(false);
                      setNamaTrainer(item.nama);
                      setNamaPeserta("");
                      setRfidTrainer(item.rfid);
                    }}
                  >
                    {item.nama}
                  </td>
                  <td
                    style={{ cursor: "pointer" }}
                    onClick={() => setNewAktif(false)}
                  >
                    {item.user}
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
      <div className={style.containerKanan}>
        {newAktif ? (
          <FormPersonalTrainer2 Terkirim={Terkirim} url={url} />
        ) : (
          <DetailPersonalTrainer
            KlikHadir={KlikHadir}
            rfidTrainer={rfidTrainer}
            UbahNamaPeserta={UbahNamaPeserta}
            namaPeserta={namaPeserta}
            url={url}
            namaTrainer={namaTrainer}
          />
        )}
      </div>
    </div>
  );
};

export default PersonalTrainerGym2;
